import React from 'react';

const Loader: React.FC = () => {
  return (
    <div className="loader-container">
      <svg
        viewBox="0 0 101.99998 101.99998"
        version="1.1"
        id="loader"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(-8.999999,-8.9999924)">
          <path
            id="rect328"
            style={{
              fill: 'none',
              stroke: '#f8f0e3',
              strokeWidth: 1,
              strokeLinecap: 'square',
              strokeLinejoin: 'inherit'
            }}
            transform="scale(1,-1)"
            d="M 9.999999,-109.99998 H 109.99998 V -9.9999924 H 9.999999 Z"
          />
          <path
            style={{
              display: 'inline',
              fill: 'none',
              stroke: '#f8f0e3',
              strokeWidth: 1,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 2,
              paintOrder: 'stroke fill markers'
            }}
            d="M 64.760292,58.868607 79.741057,87.398664"
            id="path1069"
          />
          <path
            style={{
              display: 'inline',
              fill: 'none',
              stroke: '#f8f0e3',
              strokeWidth: 1,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 2,
              paintOrder: 'stroke fill markers'
            }}
            d="M 85.939831,48.490771 57.32115,62.263164"
            id="path1067"
          />
          <path
            style={{
              fill: 'none',
              stroke: '#f8f0e3',
              strokeWidth: 1,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 2,
              paintOrder: 'stroke fill markers'
            }}
            d="M 30.319037,75.228368 57.26016,18.258513"
            id="path1061"
          />
          <path
            style={{
              fill: 'none',
              stroke: '#f8f0e3',
              strokeWidth: 1,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 2,
              paintOrder: 'stroke fill markers'
            }}
            d="m 57.263784,18.331169 0.0066,83.836551"
            id="path1063"
          />
          <path
            style={{
              fill: 'none',
              stroke: '#f8f0e3',
              strokeWidth: 1,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 2,
              paintOrder: 'stroke fill markers'
            }}
            d="m 21.269448,48.269145 81.015862,-0.03143"
            id="path1065"
          />
        </g>
      </svg>
    </div>
  );
};

export default Loader;
